/* Repair theme-rendered Seal controls without changing app settings or plans. */
(function () {
  'use strict';
  var drawers = new WeakMap();
  function focusable(drawer) {
    return Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length;
    });
  }
  function repairDrawer(drawer) {
    if (drawers.has(drawer)) return;
    var state = { open: drawer.classList.contains('sidebar--opened'), trigger: null };
    drawers.set(drawer, state);
    if (!drawer.hasAttribute('aria-label') && !drawer.hasAttribute('aria-labelledby')) {
      var title = drawer.querySelector('.sidebar__title');
      if (title && drawer.id) {
        if (!title.id) title.id = drawer.id + '-title';
        drawer.setAttribute('aria-labelledby', title.id);
      }
    }
    new MutationObserver(function () {
      var open = drawer.classList.contains('sidebar--opened');
      if (open === state.open) return;
      state.open = open;
      if (open) {
        if (!state.trigger && document.activeElement !== document.body && !drawer.contains(document.activeElement)) state.trigger = document.activeElement;
        var first = focusable(drawer)[0];
        if (first && !drawer.contains(document.activeElement)) first.focus();
      } else {
        if (state.trigger && state.trigger.isConnected && state.trigger.getClientRects().length) state.trigger.focus();
        state.trigger = null;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !state.open) return;
      var items = focusable(drawer);
      if (!items.length) { event.preventDefault(); drawer.focus(); return; }
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
  function repair(root) {
    root.querySelectorAll('sidebar-drawer').forEach(repairDrawer);
    root.querySelectorAll('.sls-selling-plan-group-first-line').forEach(function (wrapper) {
      var input = wrapper.querySelector('input.sls-option[type="radio"]');
      if (!input) return;
      // Keep one native, named radio instead of a radio nested inside an ARIA radio.
      ['role', 'tabindex', 'aria-checked', 'aria-label'].forEach(function (attr) {
        if (wrapper.hasAttribute(attr)) wrapper.removeAttribute(attr);
      });
      if (input.getAttribute('tabindex') === '-1') input.removeAttribute('tabindex');
    });
    root.querySelectorAll('.sls-subscription-details-label, .sls-more-info-popup').forEach(function (el) {
      if (el.hasAttribute('tabindex')) el.removeAttribute('tabindex');
    });
  }
  function init() {
    repair(document);
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-js-sidebar-handle][aria-controls]');
      if (!trigger) return;
      var drawer = document.getElementById(trigger.getAttribute('aria-controls'));
      if (drawer && drawers.has(drawer)) drawers.get(drawer).trigger = trigger;
    }, true);
    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      if (scheduled || !mutations.some(function (m) {
        return m.type === 'childList' || (m.target.closest && m.target.closest('.sls-purchase-options-container, .sls-more-info-container'));
      })) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; repair(document); });
    });
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['role', 'tabindex', 'aria-checked']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
